<!-- MENU -->
<div class="px-4 py-2 flex flex-row space-x-2 justify-between">
  <mat-form-field appearance="outline" class="dense-input no-subscript flex-auto">
    <input data-testid="search" matInput #filter placeholder="Поиск" i18n-placeholder />
    <button data-testid="searchButton" matSuffix mat-icon-button #filterButton>
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="dense-input no-subscript basis-28">
    <mat-label i18n>Толщина</mat-label>
    <mat-select [(ngModel)]="filterByThickness" (selectionChange)="onChangeFilterByThickness($event)">
      <mat-option value="0" i18n>Любая</mat-option>
      <mat-option [value]="item" *ngFor="let item of buttsThicknesses">{{ item }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<!-- MENU END -->

<mat-divider> </mat-divider>

<as-split direction="horizontal" [unit]="'pixel'">
  <as-split-area [size]="320">
    <csl-group-matrial-tree
      [groupMaterials]="buttGroups"
      [focusedGroupId]="focusedGroupId"
      (selectedGroupChange)="onSelectGroup($event)"
      class="ps"></csl-group-matrial-tree>
  </as-split-area>

  <as-split-area cslPerfectScrollbar>
    <mat-table #table [dataSource]="dataSource" class="material-list-table">
      <!-- Select Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mat-checkbox
            data-testid="selectButt"
            [ngModel]="isSelected(item)"
            (change)="toggleSelection(item)"
            [disabled]="item.quantityInStock < 0 && showQuantityInStock">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Texture Column -->
      <ng-container matColumnDef="texture">
        <mat-header-cell *matHeaderCellDef i18n>Текстура</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <csl-texture-viewer
            [textureLink]="item.textureLink"
            [cropTextureLink]="item.cropTextureLink"
            [color]="item.color"></csl-texture-viewer>
        </mat-cell>
      </ng-container>

      <!-- Butt Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef i18n>Наименование</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p
            #buttName
            [matTooltip]="item.name"
            [matTooltipDisabled]="!showFullNameTooltip(buttName)"
            class="text-truncate h6 p-1">
            {{ item.name }}
          </p>
        </mat-cell>
      </ng-container>

      <!-- Article Column -->
      <ng-container matColumnDef="article">
        <mat-header-cell *matHeaderCellDef i18n>Артикул</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p
            #buttArticle
            [matTooltip]="item.article"
            [matTooltipDisabled]="!showFullNameTooltip(buttArticle)"
            class="text-truncate h6 p-1">
            {{ item.article }}
          </p>
        </mat-cell>
      </ng-container>

      <!-- Thickness Column -->
      <ng-container matColumnDef="thickness">
        <mat-header-cell *matHeaderCellDef i18n>Толщина (мм)</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.thickness }}</p>
        </mat-cell>
      </ng-container>

      <!--Quantity Material Stock Column-->
      <ng-container matColumnDef="quantityInStock">
        <mat-header-cell *matHeaderCellDef i18n>Наличие на складе</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <span *ngIf="item.quantityInStock > 0"> {{ item.quantityInStock }} {{ item.measureName }} </span>
          <span i18n *ngIf="item.quantityInStock === 0">Под заказ</span>
          <span i18n *ngIf="item.quantityInStock === -1">Нет в наличии</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        class="material-list-row"
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ selected: isSelected(row) }"></mat-row>
    </mat-table>

    <div class="flex flex-row justify-center">
      <button
        class="m-8"
        color="accent"
        *ngIf="hasMore && !loading"
        (click)="pageIndex$.next(pageIndex + 1)"
        mat-stroked-button
        i18n
        >Загрузить еще</button
      >
      <mat-spinner *ngIf="loading" class="m-32" [diameter]="16"> </mat-spinner>
    </div>
  </as-split-area>
</as-split>
